import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal, Card } from "react-bootstrap";
import { useFieldArray, useForm } from "react-hook-form";
import classNames from "classnames";
import { putData } from "../../../utils/api";
import Header from "../../Header/Header";
library.add(fas);

const EditOffCanvance = (props) => {
  const id = props.show;
  const { postData, getData } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const GetEditData = async () => {
    const response = await getData(`/admin/masters/delivery-range`);
    reset(response?.data);
  };
  useEffect(() => {
    GetEditData();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const onSubmit = async (data) => {
    try {
      const response = await putData(`/admin/masters/delivery-range`, data);

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        // props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const {
    fields: GiftWrapPriceFields,
    append: GiftWrapPriceAddOn,
    remove: removeGiftWrapPrice,
  } = useFieldArray({
    control,
    name: "delivery_range",
  });
  const [CancellationPolicyError, setCancellationPolicyError] = useState("");

  useEffect(() => {
    register("delivery_range", {
      validate: (value) => {
        const isValid = value && value.length > 0;
        setCancellationPolicyError(
          isValid ? "" : "At least one Delivery Range price is required",
        );
        return isValid;
      },
    });
  }, [register]);
  const handleKeyPress = (event) => {
    if (event.key === "-" || event.key === "e") {
      event.preventDefault(); // Prevent negative sign and scientific notation
    }
  };
  return (
    <>
      {/* <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit Cloth Size
          </Modal.Title>
        </Modal.Header>
        <Modal.Body> */}

      <Header title={"Delivery Price Range"} link={"/admin/masters/crop"} />
      <div className="row MainRowsec me-0 ms-0">
        {CancellationPolicyError && (
          <div className="text-danger">{CancellationPolicyError}</div>
        )}
        <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
          <Row className="justify-content-center">
            <hr />

            {GiftWrapPriceFields.map((val, index) => (
              <div key={val.id} className="main-form-section mt-3">
                <Row className="align-items-end">
                  <Col md={6}>
                    <div className="main-form-section mt-3">
                      <Row className="justify-content-center">
                        <Form.Label>Start Kilometer</Form.Label>
                        <Form.Group>
                          <InputGroup>
                            <Form.Control
                              type="number"
                              name={`delivery_range.${index}.s_kilometer`}
                              placeholder="Start Kilometer"
                              className={classNames("", {
                                "is-invalid":
                                  errors?.delivery_range?.[index]?.s_kilometer,
                              })}
                              {...register(
                                `delivery_range.${index}.s_kilometer`,
                                {
                                  required: "Start Kilometer is required",

                                  // validate: (value) =>
                                  //   value > 0 ||
                                  //   "Start Kilometer must be greater than 0",
                                },
                              )}
                              onKeyPress={handleKeyPress}
                            />
                          </InputGroup>
                          {errors?.delivery_range?.[index]?.s_kilometer && (
                            <span className="text-danger">
                              {
                                errors?.delivery_range?.[index]?.s_kilometer
                                  .message
                              }
                            </span>
                          )}
                        </Form.Group>
                      </Row>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="main-form-section mt-3">
                      <Row className="justify-content-center">
                        <Form.Label>End Kilometer</Form.Label>
                        <Form.Group>
                          <InputGroup>
                            <Form.Control
                              type="number"
                              name={`delivery_range.${index}.e_kilometer`}
                              placeholder="End Kilometer"
                              min="0" // Ensure no negative values are allowed
                              className={classNames("", {
                                "is-invalid":
                                  errors?.delivery_range?.[index]?.e_kilometer,
                              })}
                              {...register(
                                `delivery_range.${index}.e_kilometer`,
                                {
                                  required: "End Kilometer is required",
                                  // validate: (value) =>
                                  //   value > 0 ||
                                  //   "Start Kilometer must be greater than 0",
                                },
                              )}
                              onKeyPress={handleKeyPress}
                            />
                          </InputGroup>
                          {errors?.delivery_range?.[index]?.e_kilometer && (
                            <span className="text-danger">
                              {
                                errors?.delivery_range?.[index]?.e_kilometer
                                  .message
                              }
                            </span>
                          )}
                        </Form.Group>
                      </Row>
                    </div>
                  </Col>

                  <Col md={6}>
                    <div className="main-form-section mt-3">
                      <Row className="justify-content-center">
                        <Form.Label>Price (Per km )</Form.Label>
                        <Form.Group>
                          <InputGroup>
                            <Form.Control
                              type="number"
                              name={`delivery_range.${index}.price`}
                              placeholder="price"
                              min="0" // Ensure no negative values are allowed
                              className={classNames("", {
                                "is-invalid":
                                  errors?.delivery_range?.[index]?.price,
                              })}
                              {...register(`delivery_range.${index}.price`, {
                                required: "End Kilometer is required",
                                // validate: (value) =>
                                //   value > 0 ||
                                //   "Start Kilometer must be greater than 0",
                              })}
                              onKeyPress={handleKeyPress}
                            />
                          </InputGroup>
                          {errors?.delivery_range?.[index]?.price && (
                            <span className="text-danger">
                              {errors?.delivery_range?.[index]?.price.message}
                            </span>
                          )}
                        </Form.Group>
                      </Row>
                    </div>
                  </Col>

                  <Col md={6}>
                    <button
                      className="btn btn-danger mt-3"
                      type="button"
                      onClick={() => removeGiftWrapPrice(index)}
                    >
                      Remove Delivery Range
                    </button>
                  </Col>
                </Row>
              </div>
            ))}

            <div className="main-form-section mt-3"></div>
            <hr />
            <div className="text-center">
              <button
                type="button"
                className="btn btn-primary mb-3"
                onClick={() => GiftWrapPriceAddOn({})}
              >
                + Add Delivery Range
              </button>
            </div>
            <Row className="mt-5 pb-3">
              <div className="d-flex justify-content-center">
                {/* <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link> */}

                <SaveButton
                  name={"save"}
                  handleSubmit={handleSubmit(onSubmit)}
                />
              </div>
            </Row>
          </Row>
        </Form>
      </div>
      {/* </Modal.Body>
      </Modal> */}

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
